import React, { useState, useEffect } from "react";
import { formatToBRL } from "brazilian-values";
import { CiDiscount1 } from "react-icons/ci";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { BsBank } from "react-icons/bs";
import { fetchSaldo } from "../../integration/saldo/fetchSaldo";
import { fetchDadosFinanceiro } from "../../integration/dados_financeiro/fetchDadosFinanceiro";

import { HiOutlineChartBar } from "react-icons/hi";

const FinancialSummary = () => {
  const [saldo, setSaldo] = useState(0);
  const [reservaSaldo, setReservaSaldo] = useState(0);

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    funcSaldo();
    funcConversaoPix();
  }, []);

  async function funcSaldo() {
    try {
      const resp = await fetchSaldo();
      setReservaSaldo(resp.reservefinance);
      setSaldo(resp.fullbalance);
      setErrorMessage("");
    } catch (erro) {
      setErrorMessage(erro);
    }
  }

  //puxar dados conversao pix
  const [dataConversao, setDataConversao] = useState([]);

  async function funcConversaoPix() {
    try {
      const resp = await fetchDadosFinanceiro();
      setDataConversao(resp);
      setErrorMessage("");
    } catch (erro) {
      setErrorMessage(erro);
    }
  }

  return (
    <div className="flex justify-around w-full  max-w-4xl mx-auto p-5 bg-white sm:bg-[#f2f2f2] rounded-lg shadow-md space-x-4">
      {/* Coluna 1 - Total em vendas */}
      <div className="flex flex-col items-center">
        <div className="flex justify-center -mt-11 items-center bg-[#f7f7f7] text-slate-500 rounded-full border border-slate-300 p-4">
          <AiOutlineShoppingCart size={20} />
        </div>
        <span className="text-lg font-semibold text-gray-600 mt-3">
          {formatToBRL(saldo / 100)}
        </span>
        <span className="text-xs font-light text-gray-500">
          Total em vendas
        </span>
      </div>

      {/* Coluna 3 - Outro valor */}
      <div className="flex flex-col items-center">
        <div className="flex justify-center -mt-11 items-center bg-[#f7f7f7] text-slate-500 rounded-full border border-slate-300 p-4">
          <BsBank size={20} />
        </div>
        <span className="text-lg font-semibold text-gray-600 mt-2">
          {formatToBRL(reservaSaldo / 100)}
        </span>
        <span className="text-xs font-light text-gray-500">
          Reserva financeira
        </span>
      </div>
    </div>
  );
};

export default FinancialSummary;
